var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.239864 4.99619C0.239864 5.31276 0.36568 5.63954 0.628752 5.89484L4.44902 9.7345C4.78072 10.0613 5.34118 10.0919 5.69575 9.79577C6.06176 9.49963 6.09608 9.00946 5.76438 8.68268L2.09281 4.99619L5.77582 1.30971C6.09608 0.982928 6.0732 0.482547 5.70719 0.196614C5.34118 -0.0893174 4.78072 -0.0586825 4.46046 0.257886L0.617315 4.09755C0.36568 4.35284 0.239864 4.67962 0.239864 4.99619Z","fill":"black"}));
}

ArrowLeft.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
